import React from "react";
import {LoginPage} from "./pages/account/LoginPage";
import './App.scss'
import {QueryClient, QueryClientProvider} from "react-query";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {CreateAccountPage} from "./pages/account/CreateAccountPage";
import {ChangePasswordPage} from "./pages/account/ChangePasswordPage";
import {ResetPasswordPage} from "./pages/account/ResetPasswordPage";
import {SetPasswordPage} from "./pages/account/SetPasswordPage";
import {HomePage} from "./pages/home/HomePage";
import {Container} from "react-bootstrap";
import {NavigationBar} from "./common/NavigationBar";
import {AuthProvider} from "./common/AuthProvider";
import {LoggedOutPage} from "./pages/account/LoggedOutPage";
import {SiteFooter} from "./common/SiteFooter";
import {ContestPage} from "./pages/contests/ContestPage";
import {PredictionsDetailsPage} from "./pages/contests/PredictionDetailsPage";
import {LeaderboardPage} from "./pages/contests/LeaderboardPage";
import {LegacyTokenHandler} from "./common/LegacyTokenHandler";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <NavigationBar/>
            <Container className="PageContentWidth">
              <Routes>
                <Route path="/" element={<HomePage/>}/>

                {/*Account management*/}
                <Route path="/login" element={<LoginPage/>}/>
                <Route path="/logged-out" element={<LoggedOutPage/>}/>
                <Route path="/create-account" element={<CreateAccountPage/>}/>
                <Route path="/set-password" element={<SetPasswordPage/>}/>
                <Route path="/reset-password" element={<ResetPasswordPage/>}/>
                <Route path="/change-password" element={<ChangePasswordPage/>}/>

                {/*Contest participation*/}
                <Route path="/predictions/contests/:contestId" element={<ContestPage/>}/>
                <Route path="/predictions/contests/:contestId/leaderboard" element={<LeaderboardPage/>}/>
                <Route path="/predictions/contests/:contestId/predictions/:predictionOrdinal"
                       element={<PredictionsDetailsPage/>}/>

              </Routes>
            </Container>
            <SiteFooter/>
            <LegacyTokenHandler/>
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
